import Loader from "../DomUtilities/Loader";
import openErrorModal from "../Error/ErrorModal";
import { getStorePDFHTMLString, sendStoreEmail } from "../HTTPRequests/StoreRequests";
import StoreViewModel from "../Models/ViewModels/StoreViewModel";
import PrintHandler from "../DomUtilities/PrintHandler";

export default class ResendStoreEmailModal {
	rightButton: HTMLButtonElement;
	leftButton: HTMLButtonElement;

	constructor(public store: StoreViewModel, public resendModal: HTMLDivElement) {
		this.rightButton = this.resendModal.querySelector('button + button');
		this.leftButton = this.resendModal.querySelector('button');

		this.init();
	}

	private init() {
		const messageDiv: HTMLDivElement = this.resendModal.querySelector(".modal__body > div > div");
		const message = messageDiv.innerText.replace("STORE_NAME", this.store.name);
		messageDiv.innerText = message;
		this.resendModal.style.display = "flex";

		this.addModalClickListeners();
	}

	private addModalClickListeners() {
		this.rightButton.onclick = () => {
			this.resendModal.style.display = "none";
			this.sendStoreEmail(this.store.id);
		}

		this.leftButton.onclick = () => {
			this.resendModal.style.display = "none";
			this.downloadPdf(this.store.id);
		}

		const closeImg: HTMLImageElement = this.resendModal.querySelector('img[alt="close icon"]');
		closeImg.onclick = () => {
			this.resendModal.style.display = "none";
		}

		this.resendModal.onclick = (event) => {
			if (this.resendModal.style.display !== "none" && event.target === this.resendModal) {
				this.resendModal.style.display = "none";
			}
		}
	}

	private downloadPdf(storeId: string) {
		Loader.show();
		getStorePDFHTMLString(storeId)
			.then((response: string) => {
				new PrintHandler(response).print();
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private sendStoreEmail(storeId: string) {
		Loader.show();
		sendStoreEmail(storeId)
			.then((response: string) => {
				this.openSuccessMsgModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private openSuccessMsgModal(successMessage: string) {
		openErrorModal(successMessage, "#AAC291", "  ", "30%", "130px");
	}
}
